import React, { useEffect, useMemo, useState } from "react";
import { useHistory } from "react-router-dom";

import { IonButton, IonIcon, IonToolbar, IonPage, IonContent, IonHeader, IonModal } from "@ionic/react";

import { Typography, Spin, Divider, Row, Col, notification } from "antd";
import { LoadingOutlined, BellOutlined } from "@ant-design/icons";
import { arrowDownOutline, menuOutline } from "ionicons/icons";

import SideMenu from "../../../components/orderWatcher/menu";
import OrderDetail from "../../../components/orderWatcher/orderDetail";
import OrderList from "../../../components/orderWatcher/orderList";
import socket from "../../../components/socket";

import { v4 as uuidv4 } from "uuid";
import { useTranslation } from "react-i18next";
import moment from "moment-timezone";
import c from "../../../utils/common";
import axios from "axios";
import metaData from "../../../data/metaData";
import alertSound from "../../../assets/audio/alert1.mp3"; // Path to your audio file

/* Global State*/ 
const audio = new Audio(alertSound);
const key = "updatable";
const { Paragraph } = Typography;
let globalState = undefined;
const FC = () => {
  
  const history = useHistory();
  const { t, i18n } = useTranslation();

  const [is_loading_orders, set_is_loading_orders] = useState(false);
  const [is_loading_settings, set_is_loading_settings] = useState(false);
  const [is_loading_full_order, set_is_loading_full_order] = useState(false);
  const [is_show_unread_placeholder, set_is_show_unread_placeholder] = useState(false);

  const [orders, set_orders] = useState([]);
  const [setting, set_setting] = useState();
  const [collectedOrderCount, set_collectedOrderCount] = useState(0);

  const [is_loading_accept_order, set_is_loading_accept_order] = useState(false);
  const [is_loading_reject_order, set_is_loading_reject_order] = useState(false);
  const [is_loading_cancel_after_accept_order, set_is_loading_cancel_after_accept_order] = useState(false);

  //cut order modal
  const [is_show_cut_order_modal, set_is_show_cut_order_modal] = useState(false);
  const [is_loading_cut_order, set_is_loading_cut_order] = useState(false);

  //Side Menu
  const [is_show_side_menu, set_is_show_side_menu] = useState(false);

  //Order List
  const [filter_status, set_filter_status] = useState("placed");
  const [sort, set_sort] = useState("sequence");
  const [selected_order_id, set_selected_order_id] = useState();

  const today = moment(globalState.today);

  const style = {
    order_font_1: 28,
    order_font_2: 22,
    order_font_3: 18,
    order_font_4: 14,
  };

  const get_takeaway_settings = async () => {
    set_is_loading_settings(true);
    console.log("get_takeaway_settings...");
    const query = `?vendorId=${globalState?.user?.vendorId}`;
    const res = await axios.get(globalState.serverURL + "takeaway/vendor/setting" + query, {
      headers: { Authorization: globalState.auth.jwt },
    });
    set_is_loading_settings(false);
    console.log(res);
    if (res.data.status == "Error") {
      //
    } else if (res.data.status == "Success") {
      set_setting(res.data.data);
    }
  };

  const get_takeaway_orders = async () => {
    set_is_loading_orders(true);
    console.log("get_takeaway_orders...");
    const query = `?vendorId=${globalState?.user?.vendorId}&status=placed&status=accepted`;
    const res = await axios.get(globalState.serverURL + "takeaway/order" + query, {
      headers: { Authorization: globalState.auth.jwt },
    });
    set_is_loading_orders(false);
    console.log(res);
    if (res.data.status == "Error") {
      //
    } else if (res.data.status == "Success") {
      set_orders(res.data.data);
    }
  };

  const get_collectedCount = async () => {
    console.log("get_collectedCount...");
    const query = `?vendorId=${globalState?.user?.vendorId}`;
    const res = await axios.get(globalState.serverURL + "takeaway/order/collectedCount" + query, {
      headers: { Authorization: globalState.auth.jwt },
    });
    console.log(res);
    if (res.data.status == "Error") {
      //
    } else if (res.data.status == "Success") {
      set_collectedOrderCount(res.data.data);
    }
  };

  const get_full_order_detail = async (orderId) => {
    set_is_loading_full_order(true);
    console.log("get_full_order_detail...");
    const query = `?id=${orderId}`;
    const res = await axios.get(globalState.serverURL + "takeaway/order" + query, {
      headers: { Authorization: globalState.auth.jwt },
    });
    set_is_loading_full_order(false);
    console.log(res);
    if (res.data.status == "Error") {
      //
    } else if (res.data.status == "Success") {
      set_orders((prev) => {
        return prev.map((e) => {
          if (e.id == res.data.data.id) {
            //replace order with full detail
            return res.data.data;
          } else {
            return e;
          }
        });
      });
    }
  };

  const cut_order = async (is_cut_order) => {
    set_is_loading_cut_order(true);

    let data = { vendorId: globalState?.user?.vendorId, is_cut_order };
    console.log(data);
    const res = await axios.post(globalState.serverURL + "takeaway/vendor/setting", data, {
      headers: { Authorization: globalState.auth.jwt },
    });
    console.log(res);
    set_is_loading_cut_order(false);
    if (res.data.status == "Error") {
    } else if (res.data.status == "Success") {
      // c.message({ type: "success", content: "已更新" });
      set_setting(res.data.data);
    }
  };

  const accept_order = async (orderId) => {
    set_is_loading_accept_order(true);

    let data = { orderId };

    const res = await axios.post(globalState.serverURL + "takeaway/order/accept", data, {
      headers: { Authorization: globalState.auth.jwt },
    });
    console.log(res);
    if (res.data.status == "Error") {
      //get latest data
      await get_takeaway_orders();
      c.message({ type: "error", content: "發生錯誤" });
    } else if (res.data.status == "Success") {
      //replace order with updated info
      if (res.data.data != null) {
        let updated_order = res.data.data;
        let updated = orders.map((e) => {
          if (e.id == updated_order.id) {
            return updated_order;
          } else {
            return e;
          }
        });

        set_orders(updated);
      }
    }
    set_is_loading_accept_order(false);
  };

  const reject_order = async (orderId) => {
    set_is_loading_reject_order(true);

    let data = { orderId };

    const res = await axios.post(globalState.serverURL + "takeaway/order/reject", data, {
      headers: { Authorization: globalState.auth.jwt },
    });
    console.log(res);
    if (res.data.status == "Error") {
      //get latest data
      await get_takeaway_orders();
      c.message({ type: "error", content: "發生錯誤" });
    } else if (res.data.status == "Success") {
      //remove order from local state
      if (res.data.data != null) {
        let updated = orders.filter((e) => e.id != res.data.data.id);

        set_orders(updated);
      }
    }
    set_is_loading_reject_order(false);
  };

  const cancel_after_accept_order = async (orderId) => {
    set_is_loading_cancel_after_accept_order(true);

    let data = { orderId };

    const res = await axios.post(globalState.serverURL + "takeaway/order/cancel_after_accept", data, {
      headers: { Authorization: globalState.auth.jwt },
    });
    console.log(res);
    if (res.data.status == "Error") {
      //get latest data
      await get_takeaway_orders();
      c.message({ type: "error", content: "發生錯誤" });
    } else if (res.data.status == "Success") {
      //remove order from local state
      if (res.data.data != null) {
        let updated = orders.filter((e) => e.id != res.data.data.id);

        set_orders(updated);
      }
    }
    set_is_loading_cancel_after_accept_order(false);
  };

  const loadData = async () => {
    get_takeaway_orders();
    get_collectedCount();
    get_takeaway_settings();
  };

  const sort_by_sequence_desc = (a, b) => {
    if (a.sequence > b.sequence) {
      return -1;
    }
    if (a.sequence < b.sequence) {
      return 1;
    }
    return 0;
  };

  const sort_by_total_desc = (a, b) => {
    let aTotal = getOrderTotal(a);
    let bTotal = getOrderTotal(b);

    if (aTotal > bTotal) {
      return -1;
    }
    if (aTotal < bTotal) {
      return 1;
    }
    return 0;
  };

  const sort_by_pickupTime_desc = (a, b) => {
    if (a.pickupTime < b.pickupTime) {
      return -1;
    }
    if (a.pickupTime > b.pickupTime) {
      return 1;
    }
    return 0;
  };

  const getOrderTotal = (order) => {
    if (order == null) {
      return 0;
    }
    let total = 0;
    for (let i of order.items) {
      total += getItemTotal(i);
    }
    return total;
  };

  const getItemTotal = (item) => {
    let singleItemPrice = item.drink == null ? item.price : item.price + item.drink.price;
    return singleItemPrice * item.qty;
  };

  const log_out = () => {
    // Clean up the connection when unmounts
    clearSocket();

    // globalActions.logOut();
    history.push("/login");
  };

  const playAudio = async (repeatTimes) => {
    for (let i = 0; i < repeatTimes; i++) {
      console.log(`play ${i + 1}`);
      audio.play();
      await c.sleep(3000);
    }
  };

  const shakeScreen = () => {
    // Add a class to trigger the shaking animation
    document.body.classList.add("shake");

    // Remove the class after the animation duration to reset the effect
    setTimeout(() => {
      document.body.classList.remove("shake");
    }, 1000); // Animation duration in milliseconds
  };

  const mobileVibrate = () => {
    if ("vibrate" in navigator) {
      navigator.vibrate([200, 100, 200]); // Vibrate for 200ms, pause for 100ms, vibrate for 200ms

      // Stop the vibration after a specific duration
      setTimeout(() => {
        navigator.vibrate(0);
      }, 5000);
    }
  };

  const initSocket = () => {
    if (socket.connected) {
      console.log("socket already connected...");
    } else {
      console.log("connect socket...");
      socket.on("connect", () => {
        //for reconnect
        let userId = globalState.user?.id;
        console.log(userId);
        let vendorId = globalState.user?.vendorId;
        socket.emit("join_room", [userId, vendorId, "takeawayStaff"]);
      });

      socket.on("message", (result) => {
        console.log("Received a message:", result);
      });

      socket.on("takeaway/order/place", (result) => {
        console.log("takeaway/order/place", result);
        //add order to UI
        set_orders((prev) => {
          let updated = [...prev, result.data];
          return updated;
        });

        //play audio
        playAudio(3);
        mobileVibrate();
        shakeScreen();
        set_is_show_unread_placeholder((prev) => {
          return true;
        });
      });

      socket.on("takeaway/order/cancel_before_accept", (result) => {
        console.log("takeaway/order/cancel_before_accept", result);
        //remove order from UI
        set_orders((prev) => {
          let updated = prev.filter((e) => e.id != result.data.id);
          return updated;
        });

        //unselect
        set_selected_order_id((prev) => {
          return prev == result.data.id ? null : prev;
        });
      });

      socket.on("takeaway/order/accept", (result) => {
        console.log("takeaway/order/accept", result);
        //update order from UI
        set_orders((prev) => {
          let updated = prev.map((e) => {
            if (e.id == result.data.id) {
              return result.data;
            } else {
              return e;
            }
          });
          return updated;
        });
      });

      socket.on("takeaway/order/reject", (result) => {
        console.log("takeaway/order/reject", result);
        //remove order from UI
        set_orders((prev) => {
          let updated = prev.filter((e) => e.id != result.data.id);
          return updated;
        });

        //unselect
        set_selected_order_id((prev) => {
          return prev == result.data.id ? null : prev;
        });
      });

      socket.on("takeaway/order/cancel_after_accept", (result) => {
        console.log("takeaway/order/cancel_after_accept", result);
        //remove order from UI
        set_orders((prev) => {
          let updated = prev.filter((e) => e.id != result.data.id);
          return updated;
        });

        //unselect
        set_selected_order_id((prev) => {
          return prev == result.data.id ? null : prev;
        });
      });

      socket.on("takeaway/order/collect", (result) => {
        console.log("takeaway/order/collect", result);
        get_collectedCount();
        //remove order from UI
        set_orders((prev) => {
          let updated = prev.map((e) => {
            if (e.id == result.data.id) {
              return result.data;
            } else {
              return e;
            }
          });
          return updated;
        });
      });

      socket.on("takeaway/setting", (result) => {
        console.log("takeaway/setting", result);
        //replace local state
        set_setting(result.data);
      });

      //connect
      socket.connect();
    }
  };

  const clearSocket = () => {
    if (socket) {
      console.log("clearSocket...");
      socket.removeAllListeners();
      socket.disconnect();
    }
  };

  const sendMessage = () => {
    let userId = globalState.user?.id;
    console.log(userId);
    if (userId != null) {
      socket.emit("message", {
        target: "same_roomId",
        msg: "Hello, server!",
        roomIds: [userId, "takeawayStaff"],
      });
    } else {
      console.log("userId is roomId, cannot be null");
    }
  };

  const getWeekDay = () => {
    let today_weekday_number = moment().day();
    const weekday_mapping = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"];
    let today_weekday = weekday_mapping[today_weekday_number];

    return today_weekday;
  };

  function showDayInChn(day) {
    const translations = {
      sun: "星期日",
      mon: "星期一",
      tue: "星期二",
      wed: "星期三",
      thu: "星期四",
      fri: "星期五",
      sat: "星期六",
    };

    return translations[day];
  }

  /**
   * Render Component
   */

  const Header = () => {
    return (
      <IonHeader>
        <IonToolbar>
          <Row>
            {/* Logo */}
            <Col
              span={8}
              style={{
                borderRight: "3px solid #F1F1F1",
                // backgroundColor: "red",
                padding: "10px 20px 10px 20px",
              }}
              onClick={() => {
                console.log(globalState);
                console.log(socket);
              }}
            >
              <Row justify="space-between" align="middle" style={{ width: "100%" }}>
                <Col>
                  <img
                    style={{
                      width: 50,
                      height: 50,
                      borderRadius: 5,
                    }}
                    src={metaData.blobPreURL + metaData.appLogoPath + metaData.blobPostURL}
                  />
                </Col>
                <Col>
                  <span>
                    <span style={{ fontSize: 20 }}>今日已提取訂單</span>
                  </span>
                </Col>
                <Col>
                  <span style={{ fontSize: 32, marginLeft: 10 }}>{collectedOrderCount}</span>
                </Col>
              </Row>
            </Col>

            {/* Placeholder */}
            <Col
              flex="auto"
              style={{
                //backgroundColor: "blue",
                padding: 20,
              }}
            ></Col>

            {/* Cut Order Status */}
            <Col
              flex="none"
              style={{
                //backgroundColor: "lightgreen",
                padding: "10px 20px 10px 20px",
                borderLeft: "3px solid #F1F1F1",
              }}
              onClick={() => {
                if (is_loading_settings == false && is_loading_cut_order == false) {
                  set_is_show_cut_order_modal(true);
                }
              }}
            >
              <Row align="middle" style={{ height: "100%" }}>
                {is_loading_settings || is_loading_cut_order ? (
                  <Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} />
                ) : getIsCutOrder() ? (
                  <>
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                      <circle cx="6" cy="6" r="6" fill="#FC7777" />
                    </svg>
                    <span style={{ fontSize: 26, marginLeft: 10 }}>已截單</span>
                  </>
                ) : (
                  <>
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                      <circle cx="6" cy="6" r="6" fill="#15B565" />
                    </svg>
                    <span style={{ fontSize: 26, marginLeft: 10 }}>營業中</span>
                  </>
                )}
              </Row>
            </Col>

            {/* Menu Btn */}
            <Col
              flex="none"
              style={{
                //backgroundColor: "green",
                padding: "10px 20px 10px 20px",
                borderLeft: "3px solid #F1F1F1",
              }}
              onClick={() => {
                set_is_show_side_menu(true);
              }}
            >
              <Row align="middle" style={{ height: "100%" }}>
                <IonIcon style={{ fontSize: 48 }} icon={menuOutline} />
              </Row>
            </Col>
          </Row>
        </IonToolbar>
      </IonHeader>
    );
  };

  const OrderTabs = () => {
    return (
      <Row
        justify="space-between"
        align="middle"
        style={{
          width: "100%",
          height: 80,
          fontSize: 32,
          fontWeight: "bold",
          borderRight: "3px solid #F1F1F1",
        }}
      >
        <Col
          span={12}
          style={{ height: "100%" }}
          onClick={() => {
            set_filter_status("placed");
          }}
        >
          <Row
            justify="center"
            align="middle"
            style={{
              padding: 10,
              height: "100%",
              borderRight: "3px solid #F1F1F1",
              backgroundColor: filter_status == "placed" ? "#F2E8FF" : "white",
            }}
          >
            新訂單
            <span style={{ color: "#CB4BCD" }}>{orders.filter((e) => e.status == "placed").length}</span>
          </Row>
        </Col>
        <Col
          span={12}
          style={{
            height: "100%",
          }}
          onClick={() => {
            set_filter_status("accepted");
          }}
        >
          <Row
            justify="center"
            align="middle"
            style={{
              padding: 10,
              height: "100%",
              backgroundColor: filter_status == "accepted" ? "#F2E8FF" : "white",
            }}
          >
            已接受
            <span style={{ color: "#CB4BCD" }}>{orders.filter((e) => e.status == "accepted").length}</span>
          </Row>
        </Col>
      </Row>
    );
  };

  const OrderSort = () => {
    return (
      <Row
        justify="center"
        align="middle"
        onClick={() => {
          if (sort == "sequence") {
            set_sort("total");
          }
          if (sort == "total") {
            set_sort("pickupTime");
          }
          if (sort == "pickupTime") {
            set_sort("sequence");
          }
        }}
        style={{
          height: 50,
          fontSize: 20,
          padding: 5,
          borderRight: "3px solid #F1F1F1",
          borderTop: "3px solid #F1F1F1",
        }}
      >
        {sort == "sequence" ? "單號較大排先" : null}
        {sort == "total" ? "總額較大排先" : null}
        {sort == "pickupTime" ? "提取時間較早排先" : null}
        <IonIcon icon={arrowDownOutline} />
      </Row>
    );
  };

  const getActiveTimeSlotIndex = () => {
    let activeTimeSlotIndex;
    let timeSlots = setting?.takeaway_timetable?.[getWeekDay()];
    if (timeSlots?.length > 0) {
      for (let i = 0; i < timeSlots.length; i++) {
        if (moment().isBetween(moment(timeSlots[i].start, "HH:mm"), moment(timeSlots[i].end, "HH:mm"))) {
          activeTimeSlotIndex = i;
        }
      }
    }

    return activeTimeSlotIndex;
  }

  const getIsCutOrder = () => {
    return getActiveTimeSlotIndex() == null || setting?.is_cut_order;
  }

  const CutOrderModal = () => {
    return (
      <IonModal
        isOpen={is_show_cut_order_modal}
        cssClass="center-round-modal auto-height"
        onDidDismiss={() => {
          set_is_show_cut_order_modal(false);
        }}
        mode="ios"
        swipeToClose
      >
        <Row style={{ width: "40vw", padding: 20, fontWeight: "bold" }} className="inner-content">
          <Row style={{ width: "100%", padding: 10, marginBottom: 20 }}>
            <Row justify="start" align="middle" style={{ width: "100%" }}>
              <Col span={21} style={{ fontSize: 28 }}>
                {/* {showDayInChn(getWeekDay())} */}
                {getIsCutOrder() ? (
                  <Row justify="start" align="middle" style={{ width: "100%" }}>
                    <Col span={3}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                        <circle cx="6" cy="6" r="6" fill="#FC7777" />
                      </svg>
                    </Col>
                    <Col span={21} style={{ fontSize: 28 }}>
                      已截單
                    </Col>
                  </Row>
                ) : (
                  <Row justify="start" align="middle" style={{ width: "100%" }}>
                    <Col span={3}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                        <circle cx="6" cy="6" r="6" fill="#05A315" />
                      </svg>
                    </Col>
                    <Col span={21} style={{ fontSize: 28 }}>
                      營業中
                    </Col>
                  </Row>
                )}
              </Col>
            </Row>
            <Row style={{ width: "100%", marginBottom: 20 }}>
              <Col style={{ fontSize: 22 }}>當前{getActiveTimeSlotIndex() == null ? "不" : null}是接單時段</Col>
            </Row>
            {setting?.takeaway_timetable?.[getWeekDay()]?.length > 0
              ? setting.takeaway_timetable[getWeekDay()].map((timeSlot, timeSlotIndex) => (
                  <Row
                    key={timeSlotIndex}
                    style={
                      timeSlotIndex == getActiveTimeSlotIndex()
                        ? { width: "100%", border: "3px solid #000000", padding: 5, borderRadius: 5 }
                        : { width: "100%", padding: 5, borderRadius: 5 }
                    }
                  >
                    {timeSlot.start} - {timeSlot.end}
                  </Row>
                ))
              : null}
          </Row>

          <Row style={{ width: "100%" }} gutter={10}>
            {getIsCutOrder() == false ? (
              <Col
                span={24}
                onClick={() => {
                  cut_order(true);
                  set_is_show_cut_order_modal(false);
                }}
                style={{ padding: 10, borderRadius: 20, backgroundColor: "#f5f5f5" }}
              >
                <Row justify="center" align="middle" style={{ width: "100%", fontSize: 28 }}>
                  切換至全部截單
                </Row>
              </Col>
            ) : getActiveTimeSlotIndex() != null ? (
              <Col
                span={24}
                onClick={() => {
                  cut_order(false);
                  set_is_show_cut_order_modal(false);
                }}
                style={{ padding: 10, borderRadius: 20, backgroundColor: "#f5f5f5" }}
              >
                <Row justify="center" align="middle" style={{ width: "100%", fontSize: 28 }}>
                  切換至營業中
                </Row>
              </Col>
            ): null}
          </Row>

          <Row style={{ width: "100%" }}></Row>
        </Row>
      </IonModal>
    );
  };

  const orders_filtered = useMemo(() => {
    console.log(orders.length);
    console.log({ filter_status });

    //early exit
    if (orders.length == 0) {
      return [];
    }

    let filtered = [];

    //filter by status
    filtered = orders.filter((e) => e.status == filter_status);

    //sort
    if (sort == "sequence") {
      filtered.sort(sort_by_sequence_desc);
    } else if (sort == "total") {
      filtered.sort(sort_by_total_desc);
    } else if (sort == "pickupTime") {
      filtered.sort(sort_by_pickupTime_desc);
    }

    console.log(filtered.length);

    return filtered;
  }, [orders, filter_status, sort]);

  const selected_order = useMemo(() => {
    return orders_filtered.find((e) => e.id == selected_order_id);
  }, [orders_filtered, selected_order_id]);

  useEffect(() => {
    if (window.location.pathname == "/orderWatcher/dashboard/recentOrder") {
      initSocket();
      loadData();
    }
    return () => {
      clearSocket();
    };
  }, [window.location.pathname]);

  return (
    <IonPage>
      {is_show_unread_placeholder ? (
        <Row
          justify="center"
          align="middle"
          style={{
            width: "100%",
            height: "100%",
            backgroundColor: "#CB4BCD",
            color: "white",
            fontSize: 48,
            fontWeight: "bold",
            animation: "order-placeholder-flash-infinite 12s infinite",
          }}
          onClick={() => {
            set_selected_order_id();
            set_filter_status("placed");
            set_is_show_unread_placeholder(false);
          }}
        >
          <Row justify="center" style={{ width: "100%" }}>
            你有新訂單
          </Row>
          <Row justify="center" style={{ fontSize: 20, width: "100%" }}>
            點擊任何位置以繼續
          </Row>
        </Row>
      ) : (
        <>
          <Header />

          <CutOrderModal />

          <SideMenu
            isShow={is_show_side_menu}
            history={history}
            onClose={() => {
              set_is_show_side_menu(false);
            }}
            onLogOut={() => {
              log_out();
            }}
          />

          <IonContent style={{ "--overflow": "hidden" }}>
            <Row style={{ height: "100%" }}>
              {/* Order List */}
              <Col span={8} style={{ height: "100%" }}>
                <OrderTabs />
                <OrderSort />
                <OrderList
                  is_loading_orders={is_loading_orders}
                  orders_filtered={orders_filtered}
                  selected_order_id={selected_order_id}
                  onSelect={(orderId) => {
                    if (selected_order_id == orderId) {
                      //unselect
                      set_selected_order_id();
                    } else {
                      //select
                      set_selected_order_id(orderId);
                    }
                  }}
                  css={{ height: "calc(100% - 130px)" }}
                />
              </Col>

              <Col span={16} style={{ padding: 20, height: "100%" }}>
                <OrderDetail
                  order={selected_order}
                  is_loading_accept_order={is_loading_accept_order}
                  onAcceptOrder={(orderId) => accept_order(orderId)}
                  is_loading_reject_order={is_loading_reject_order}
                  onRejectOrder={(orderId) => reject_order(orderId)}
                  is_loading_cancel_after_accept_order={is_loading_cancel_after_accept_order}
                  onCancelAfterAcceptOrder={(orderId) => cancel_after_accept_order(orderId)}
                  is_loading_full_order={is_loading_full_order}
                  onGetFullDetail={(orderId) => {
                    get_full_order_detail(orderId);
                  }}
                />
              </Col>
            </Row>
          </IonContent>
        </>
      )}
    </IonPage>
  );
};

export default FC;
